import React from 'react';
import useGoToPage from '../../hooks/useGoToPage';
import pages from '../../routes/pages';
import { ReactComponent as Tools } from '../../assets/svg/tool.svg';
import { ReactComponent as FavFolder } from '../../assets/svg/fav-folder.svg';
import { ReactComponent as Rocket } from '../../assets/svg/rocket.svg';
import useStyle from './Document.style';
import { classNames } from '../../helpers/style/classNames';

export const Documents = () => {
  const classes = useStyle();
  const goToRessourcePage = useGoToPage(pages.RESSOURCES_PAGE.path);
  const goToPedagogiePage = useGoToPage(pages.PEDAGOGIES_PAGE.path);
  const goToFormationPage = useGoToPage(pages.FORMATIONS_PAGE.path);

  return (
    <div className={classes.root}>
      <h3 className={classes.title}>Choisir une catégorie :</h3>
      <div className={classes.container}>
        <div
          onClick={goToPedagogiePage}
          className={classNames([classes.button, classes.pedagogie])}
        >
          <p className={classes.paragraph}>Pédagogie</p>
          <FavFolder />
        </div>
        <div
          onClick={goToFormationPage}
          className={classNames([classes.button, classes.formation])}
        >
          <p className={classes.paragraph}>Formation</p>
          <Tools />
        </div>
        <div
          onClick={goToRessourcePage}
          className={classNames([classes.button, classes.challenge])}
        >
          <p className={classes.paragraph}>Challenge</p>
          <Rocket />
        </div>
      </div>
    </div>
  );
};
